/** CostTag — a small colored badge showing a part's cost type (Calculation / Onsite / None). */
import type { TFunction } from 'i18next';

import type { PlaceholderCostType } from '@/api/generated/schemas';
import { COST_TONE } from '../model';

export function CostTag({ t, costType }: { t: TFunction; costType: PlaceholderCostType }) {
  return (
    <span className="tp-costtag" data-cost={COST_TONE[costType]}>
      {t(`costScheme.costTypes.${costType}`)}
    </span>
  );
}
